import React from "react";
import { Text } from "@showitinc/showit-wc";

import useRenderer from "../hooks/query/useRenderer";
import { useSiteState } from "../hooks/query/useSite";
import UpgradedIcon from "./UpgradedIcon";
import styles from "./PublishPanel.module.css";

/**
 * Renders the "Publishing with latest version of Showit" indicator inside the
 * publish modal when the design is locked into v2. Sits alongside
 * ProtorendererToggle, which self-hides when `!canToggle`; the two are mutually
 * exclusive by construction.
 *
 * @returns {React.ReactElement|null}
 */
const PublishUpgradedIndicator = () => {
  const siteId = useSiteState().get("site_design_id");
  const { canToggle, settled: rendererSettled } = useRenderer(siteId, {
    enabled: siteId != null,
  });
  const isUpgraded = rendererSettled && !canToggle;

  if (!isUpgraded) {
    return null;
  }

  return (
    <div className={styles["upgraded-indicator"]}>
      <UpgradedIcon className={styles["upgraded-indicator-icon"]} />
      <Text>Publishing with latest version of Showit</Text>
    </div>
  );
};

export default PublishUpgradedIndicator;
